module.exports = __webpack_public_path__ + "static/media/circles.3010a1e6.jpg";